import React from 'react'
import moment from 'moment'
import _cx from 'classnames/bind'
import PropTypes from 'prop-types'
import { Table } from '@adc/ui-adc'
import { formatMoneyWithNumeral, formatNumber } from '../../utils/formatters'
import { buildRow, DataNotAvailable, privateView, CompCard } from './utils'
import cls from './index.scss'
const cx = _cx.bind(cls)

const elmId = 'comp_sales'
const FIELDS = [
  {
    label: 'Address',
    fieldPath: 'address.fulladdress',
  },
  {
    label: 'Sale Price',
    fieldPath: 'info.soldprice',
    format: price => formatMoneyWithNumeral(price, '-'),
  },
  {
    label: 'Sale Date',
    fieldPath: 'info.solddate',
    format: soldDate =>
      moment(soldDate, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YYYY'),
  },
  {
    label: 'Distance',
    fieldPath: 'distance',
    format: dist =>
      dist !== '-' ? <span className={cx('u-nowrap')}>{dist} mi</span> : '-',
  },
  {
    label: 'Bed',
    fieldPath: 'info.bedrooms',
  },
  {
    label: 'Bath',
    fieldPath: 'info.bathrooms',
  },
  {
    label: 'Sq. ft',
    fieldPath: 'info.livingarea',
    format: formatNumber,
  },
  {
    label: 'Lot Size',
    fieldPath: 'info.landarea',
    format: landarea =>
      landarea !== '-' ? `${(landarea / 43560).toFixed(2)} Acres` : '-',
  },
  {
    label: 'Built',
    fieldPath: 'info.yearbuilt',
    elmId: 'year_built',
  },
  {
    label: 'Source',
    fieldPath: 'source',
    format: source => (source === 'dataquick' ? 'Public Records' : 'MLS'),
  },
]

class LocalComps extends React.Component {
  get show() {
    return this.props.comps.length > 0
  }

  render() {
    const { comps, loading, selectedProperty, selectPin, deSelectPin } =
      this.props

    if (loading) return null

    const selectedAsset = selectedProperty >= 0 && comps[selectedProperty]

    return !this.show ? (
      <DataNotAvailable />
    ) : (
      <>
        <div className={cx('hide-on-small', 'u-mt-2')}>
          <Table selectable>
            <Table.Header>
              <Table.Row>
                {FIELDS.map(field => (
                  <Table.HeaderCell key={field.label}>
                    {field.label}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {comps.map((comp, i) =>
                buildRow({
                  comp,
                  elmId,
                  fields: FIELDS,
                  key: i,
                  active: selectedProperty === i,
                  onMouseEnter: selectPin(i),
                  onMouseLeave: deSelectPin(),
                })
              )}
            </Table.Body>
          </Table>
        </div>
        {selectedAsset && (
          <div className={cx('show-on-small')}>
            <CompCard comp={selectedAsset} fields={FIELDS} />
          </div>
        )}
      </>
    )
  }
}

LocalComps.propTypes = {
  comps: PropTypes.array.isRequired,
  selectedProperty: PropTypes.number.isRequired,
  selectPin: PropTypes.func.isRequired,
  deSelectPin: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

export default privateView(LocalComps)
